import { z } from 'zod';
import { validator } from '@xeppt/xeppt-sdk';

export const getPhoneValidation = (
    messages: { phone: string; verification: string },
    phoneVerification?: boolean
) => {
    if (phoneVerification) {
        return z.object({
            verificationCode: validator.verificationCode(messages.verification)
        });
    } else {
        return z.object({
            phone_number: validator.phone(messages.phone),
            phone_code: validator.phoneCode(messages.phone)
        });
    }
};

/**
 * Validates if a string is a valid email address
 * @param email - Email string to validate
 * @returns boolean - True if valid email
 */
export const isValidEmail = (email: string): boolean => {
    if (!email || typeof email !== 'string') {
        return false;
    }

    // Basic regex pattern for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Trim whitespace
    const trimmedEmail = email.trim();

    // Check basic format
    if (!emailRegex.test(trimmedEmail)) {
        return false;
    }

    // Additional validation checks
    if (trimmedEmail.length > 254) {
        // RFC 5321 limit
        return false;
    }

    const [localPart, domainPart] = trimmedEmail.split('@');

    // Local part validation (before @)
    if (localPart.length > 64) {
        // RFC 5321 limit
        return false;
    }

    // Domain part validation (after @)
    if (domainPart.length > 253) {
        return false;
    }

    // Check for consecutive dots
    if (trimmedEmail.includes('..')) {
        return false;
    }

    // Check if starts or ends with dot
    if (localPart.startsWith('.') || localPart.endsWith('.')) {
        return false;
    }

    return true;
};
